export const ALREADY_INIT = 'ALREADY_INIT';
export const CHANGE_DATE = 'CHANGE_DATE';
export const CHANGE_PRODUCT_DATE = 'CHANGE_PRODUCT_DATE';


// WEBPACK FOOTER //
// ./src/components/UpdateSystem/updateSystemActionTypes.js